import UserMainLayout from '@/components/app/layouts/user-main-layout';
import TemplateView from '@/components/app/templates/template-view/TemplateView';
import AuthProtected from '@/components/app/utils/auth-protected/AuthProtected';
import { Stack } from '@mui/system';
import { useRouter } from 'next/router';

export default function TemplatePage() {
   const router = useRouter();
   const { slug } = router.query;

   return (
      <div>
         <Stack direction="column" spacing={32} p={8}>
            <TemplateView slug={slug} />
         </Stack>
      </div>
   );
}

TemplatePage.getLayout = (page) => (
   <AuthProtected>
      <UserMainLayout type="templates">{page}</UserMainLayout>
   </AuthProtected>
);
